import { useEffect, useState } from 'react'

interface CountdownParts {
  horas: string
  minutos: string
  segundos: string
}

const pad = (value: number): string => String(value).padStart(2, '0')

export function useCountdown(totalSeconds: number): CountdownParts {
  const [restante, setRestante] = useState<number>(totalSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRestante((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    horas: pad(Math.floor(restante / 3600)),
    minutos: pad(Math.floor((restante % 3600) / 60)),
    segundos: pad(restante % 60),
  }
}
